import { ResponseService } from './../services/response.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from './../services/api.service';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';


@Component({
    selector: 'app-cloud-dashboard',
    templateUrl: './cloud-dashboard.component.html'
})

export class CloudDashboardComponent implements OnInit {

    // Zmienna mówiąca o pobieraniu danych
    public loadingCloudData: Boolean = true;
    public cloudIsReady: Boolean = false;

    // Obiekt serwera
    public cloud: any;
    public uuid: String;


    /**
     * Creates an instance of ServerDashboardComponent.
     * @param {ApiService} apiService 
     * @param {ActivatedRoute} router 
     * 
     * @memberOf CloudDashboardComponent
     */
    constructor(
        private apiService: ApiService,
        private responseService: ResponseService,
        private route: ActivatedRoute,
        private breadcrumbService: BreadcrumbService,

        private router: Router
    ) {
    }



    /**
     * Funkcja inicjalizujaca
     * 
     * 
     * @memberOf CloudDashboardComponent
     */
    ngOnInit() {
        this.route.params.subscribe(params => {
            this.uuid = String(params['uuid']);
            this.getCloudInfo(this.uuid);
        });
    }



    private getCloudInfo(uuid: String): void {
        this.loadingCloudData = true;
        this.apiService.get('/cloud/' + uuid).subscribe(
            (response) => {
                const cloud = this.responseService.success(false, response, 'cloud');
                this.cloud = cloud;
                this.cloudIsReady = (this.cloud.status === 'active' ? true : false); // Tu ustawić sprawdzenie cloud.status
                if(this.cloudIsReady){
                    this.breadcrumbService.addFriendlyNameForRoute('/cloud/' + uuid, cloud.name);
                }
                this.loadingCloudData = false;
            },
            (error) => {
                this.responseService.error(error);
            }
        );
    }



}



// WEBPACK FOOTER //
// ./src/app/cloud/cloud-dashboard.component.ts